//  ['CountryId', 'CountryName', 'CountryRef', 'ISOCode'],
const countries = [
  ['1', 'United Kingdom', 'UK', 'UK'],
  ['2', 'Italy', 'IT', 'IT'],
  ['3', 'Germany', 'DE', 'DE'],
  ['4', 'France', 'FR & NL', 'FR'],
  ['5', 'Japan', 'JP', 'JP'],
  ['6', 'Sweden', 'SE', 'SE'],
  ['7', 'Denmark', 'DK', 'DK'],
  ['8', 'Spain', 'SP', 'ES'],
  ['9', 'United States', 'US', 'US'],
  ['10', 'Australia', 'AU', 'AU'],
  ['11', 'Netherlands', 'NL', 'NL'],
  ['12', 'Belgium', 'BE', 'BE'],
  ['13', 'Ireland', 'IRL', 'IE'],
  ['14', 'Norway', 'NO', 'NO'],
  ['15', 'Finland', 'FI', 'FI'],
  ['16', 'Austria', 'AT', 'AT'],
  ['17', 'Switzerland', 'CH', 'CH'],
  ['18', 'Canada', 'CA', 'CA'],
  ['19', 'Mexico', 'MX', 'MX'],
  ['20', 'Hong Kong', 'HK', 'HK'],
  ['21', 'Singapore', 'SG', 'SG'],
  ['22', 'Portugal', 'PT', 'PT'],
  ['23', 'Luxembourg', 'LU', 'LU'],
];

export default countries;
